import apiService from '../apiService';

const URL = 'demand-letters';

const fail = (error) => {
  throw error?.response?.data || error;
};

const post = async (path, payload = {}) => {
  try {
    const response = await apiService.post(`/${URL}/${path}`, payload);
    return response.data;
  } catch (error) {
    fail(error);
  }
};

const demandLetterService = {
  async rules() {
    try {
      const response = await apiService.get(`/${URL}/rules`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  generate: (payload) => post('generate', payload),

  async get(id) {
    try {
      const response = await apiService.get(`/${URL}/${id}`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async update(id, payload) {
    try {
      const response = await apiService.put(`/${URL}/${id}`, payload);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async remove(id) {
    try {
      const response = await apiService.delete(`/${URL}/${id}`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  regenerate: (id) => post(`${id}/regenerate`),

  async preview(id) {
    try {
      const response = await apiService.get(`/${URL}/${id}/preview`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  /** Resolves to a Blob. */
  async pdf(id) {
    try {
      const response = await apiService.get(`/${URL}/${id}/pdf`, { responseType: 'blob' });
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  async checklist(id, sentVia = []) {
    try {
      const response = await apiService.get(`/${URL}/${id}/checklist`, { params: { sent_via: sentVia } });
      return response.data;
    } catch (error) {
      fail(error);
    }
  },

  requestApproval: (id, payload = {}) => post(`${id}/request-approval`, payload),
  approve: (id, payload = {}) => post(`${id}/approve`, payload),
  rejectApproval: (id, payload = {}) => post(`${id}/reject-approval`, payload),
  send: (id, payload) => post(`${id}/send`, payload),
  revise: (id) => post(`${id}/revise`),
  voidLetter: (id, reason = null) => post(`${id}/void`, { reason }),
  addNegotiation: (id, payload) => post(`${id}/negotiations`, payload),

  async removeNegotiation(id, entryId) {
    try {
      const response = await apiService.delete(`/${URL}/${id}/negotiations/${entryId}`);
      return response.data;
    } catch (error) {
      fail(error);
    }
  },
};

export default demandLetterService;
